// Este arquivo é usado para forçar uma nova build no Vercel
// Atualizando a versão de build para testar o deploy automático
export const BUILD_VERSION = '1.0.5';
